import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import { alertState } from "src/recoil/atoms/global";
import { useMutation } from "src/Hooks/useReactQuery";
import { deployInstance } from "src/services/project-instances";

const useDeployInstance = (toggle) => {
  const { t } = useTranslation("project-instance");
  const showAlert = useSetRecoilState(alertState);

  const deployInstanceMutation = useMutation({
    mutationFn: (data) => deployInstance({ data }),
  });

  const submitData = ({ data }, callback) => {
    deployInstanceMutation.mutate(data, {
      onSuccess: () => {
        showAlert({
          status: true,
          message: t("deploying"),
          type: "success",
        });
        callback?.();
      },
      onSettled: () => {
        toggle();
      },
    });
  };

  return {
    deployInstanceMutation,
    submitData,
    isLoading: deployInstanceMutation.isLoading,
    isError: deployInstanceMutation.isError,
    error: deployInstanceMutation.error,
  };
};

export default useDeployInstance;
